import { Icon, Stack, Text } from '@chakra-ui/react';
import { TemplateIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

import { CompanyType, useGetCompanyQuery } from '@blockpulse3/graphql/hooks';

import { useParams } from 'react-router-dom';
import { ShareholderTable } from '../ShareholderTable';
import { CapTableInformations } from './CapTableInformations';

type Props = unknown;

/**
 * CapTableView.
 * Main captable view, rendering specific captable informations and the list of shareholders.
 *
 * @returns {JSX.Element}
 */
export function CapTableView(): JSX.Element {
  const i18nCapTableInformations = useTranslations('CapTableInformations');

  const { companyId = '' } = useParams();
  const companyReq = useGetCompanyQuery({
    variables: { companyId },
    skip: !companyId,
  });
  const company = companyReq?.data?.company;

  if (company?.type === CompanyType.PARTIAL) {
    return (
      <Stack layerStyle="emptyState">
        <Icon as={TemplateIcon} boxSize="40px" color="gray.500" />
        <Stack alignItems="center" spacing="0">
          <Text>{i18nCapTableInformations('EmptyStateTitle-1')}</Text>
          <Text>{i18nCapTableInformations('EmptyStateTitle-2')}</Text>
        </Stack>
      </Stack>
    );
  }
  return (
    <Stack spacing="4">
      <CapTableInformations />
      <ShareholderTable />
    </Stack>
  );
}

export type CapTableViewProps = Props;
